import axios from "axios";
import { sortEmployeeName } from '@/mixins/sort';

export default {
  namespaced: true,
  state: {
    employees: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    employeesMessage: ''
  },
  mutations: {
    RECEIVED_USERS(state, payload) {
      payload.sort(sortEmployeeName);
      state.employees = payload;
      state.isReceiving = false;
    },
    RECEIVING_USERS(state) {
      state.isReceiving = true;
    },
    RECEIVED_USER(state, payload) {
      state = Object.assign(state, {
        employees: [...state.employees, payload],
        isReceiving: false,
      })
    },
    RECEIVING_USER(state) {
      state.isReceiving = true;
    },
    UPDATED_USER(state, payload) {
      let index = state.employees.findIndex(employee => employee._id === payload._id);
      state = Object.assign(state, {
        employees: state.employees.map((employee, i) => {
          if (i === index) {
            return Object.assign({}, employee, payload);
          }
          return employee;
        }),
        isUpdating: false,
        employeesMessage: 'Employees has been updating!',
      })
    },
    UPDATING_USER(state) {
      state.isUpdating = true;
    },
    DELETED_USER(state, payload) {
      let indexToDelete = state.employees.findIndex(employee => employee._id === payload._id);
      let employees = [...state.employees];
      employees.splice(indexToDelete, 1);
      state = Object.assign(state, {
        employees: [...employees],
        isDeleting: false,
        idToDelete: null,
        employeesMessage: 'Employee has been Deleted!',
      });
    },
    DELETING_USER(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    getEmployeesRequest({dispatch}) {
      dispatch("receivingEmployees");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/employees';
      let headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };

      return axios({method: "get",url: url,headers: headers})
      .then(res => {
        dispatch("receiveEmployees", res.data);
      });
    },
    updateEmployeeRequest({dispatch}, payload) {
      dispatch("updatingEmployee");
      var id = payload._id;
      delete payload['_id'];
      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/update/employee/' + id;
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var post = {
        method: "post",
        url: url,
        headers: header,
        data: payload,
      };

      axios(post)
      .then(function (res) {
        dispatch("updateEmployee", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    updateEmployeeImageRequest({dispatch}, payload) {
      dispatch("updatingEmployee");
      var data;
      var header;
      var token = localStorage.getItem('token');
      var id = payload._id;
      delete payload['_id'];
      var url = 'https://api.accountxc.com:3100/update/employee/image/' + id;
      data = new FormData();
      data.append('image', payload.employeeimage, payload.imagename); 
      delete payload['employeeimage'];
      for (let x in payload) {
        data.append(x, payload[x]);
      }
      header = {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + token
      };

      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };

      axios(post)
      .then(function (res) {
        dispatch("updateEmployee", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    createEmployeeRequest({dispatch}, payload) {
      dispatch("receivingEmployees");
      var url;
      var data;
      var header;
      var token = localStorage.getItem('token');

      if(payload.employeeimage !== undefined) {
        url = 'https://api.accountxc.com:3100/insert/employee/withimage';
        data = new FormData();
        data.append('image', payload.employeeimage, payload.imagename); 
        delete payload['employeeimage'];
        for (let x in payload) {
          data.append(x, payload[x]);
        }
        header = {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + token
        };
      } else {
        url = 'https://api.accountxc.com:3100/insert/employee';
        data = payload;
        header = {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        };
      }
      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };
      axios(post)
      .then(function (res) {
        dispatch("receiveEmployee", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });	
    },
    deleteEmployeeRequest({dispatch}, payload) {
      dispatch("deletingEmployee", payload);
      axios.get('https://api.accountxc.com:3100/delete/employee/' + payload._id).then(() => {
        dispatch("deleteEmployee", {_id: payload._id});
      })
    },
    receiveEmployees({commit}, payload) {
      commit("RECEIVED_USERS", payload)
    },
    receivingEmployees({commit}) {
      commit("RECEIVING_USERS")
    },
    receiveEmployee({commit}, payload) {
      commit("RECEIVED_USER", payload)
    },
    receivingEmployee({commit}) {
      commit("RECEIVING_USER")
    },
    updateEmployee({commit}, payload) {
      commit("UPDATED_USER", payload)
    },
    updatingEmployee({commit}) {
      commit("UPDATING_USER")
    },
    deleteEmployee({commit}, payload) {
      commit("DELETED_USER", payload)
    },
    deletingEmployee({commit}, payload) {
      commit("DELETING_USER", payload)
    }
  },
};
